<script setup lang="ts">
import GlobalLoader from '@/shared/ui/global-loader.vue';
import { SidebarProvider } from '@/shared/ui/sidebar';
import TailwindScreenHelper from '@/shared/ui/tailwind-screen-helper.vue';
import { SearchOverlay } from '@/widgets/search-overlay';
import { Sidebar } from '@/widgets/sidebar';
import TopNavigation from '@/widgets/top-navigation.vue';
</script>

<template>
  <div class="flex min-h-screen flex-col">
    <SidebarProvider>
      <Sidebar />
      <GlobalLoader />
      <TailwindScreenHelper />
      <SearchOverlay />

      <main class="flex min-w-0 flex-1 flex-col px-4 py-8 lg:px-8">
        <div class="mx-auto flex w-full max-w-7xl flex-1 flex-col pt-16">
          <TopNavigation />
          <RouterView />
        </div>
      </main>
    </SidebarProvider>
  </div>
</template>
